	<div class="paging-container">
		<app-common-table-paging
			#tablePaging
			[isPaging]="true"
			[totalNum]="totalNum"
			[pageSize]="pageSize"
			(paging)="onPaging($event)"
		></app-common-table-paging>
	</div>
	<div class="source-table">
		<app-common-datagrid
			[id]="sourceTableId"
			[columns]="sourceColumns"
			[rows]="sourceRows"
			[hidePaging]="true"
			[rowClass]="setRowClass"
			[sorts]="tableSorts"
			[sortType]="'single'"
			[selectionType]="'single'"
			[selectedRows]="selectedSourceRows"
			(select)="onSelectRow($event, 'source')"
			(scroll)="onScroll($event, resultTableId)"
			(activate)="onActivate($event)"
			(sort)="onSort($event, sourceTableId)"
			(tableContextmenu)="onContextmenu($event)"
		></app-common-datagrid>
	</div>
	<div class="middle-tab-section">
		<app-feat-layer-tabs [disabled]="true" [onlyCurrent]="true"></app-feat-layer-tabs>
		<div class="slide-switch">
			<label>Legacy</label>
				<mat-slide-toggle
					class="unbiased-slide-toggle"
					[(ngModel)]="isShowNena"
					(change)="setSourceColumnsByType()">
				</mat-slide-toggle>
			<label>Nena</label>
		</div>
		<div class="parse-code-filter">
			<select name="parseCodeFilter" [(ngModel)]="selectedParseCode" (ngModelChange)="filterRowsByParseCode()">
				<option *ngFor="let code of parseCodes" [ngValue]="code">{{code.label}}</option>
			</select>
		</div>
	</div>
	<div class="result-table">
		<app-common-datagrid
			[id]="resultTableId"
			[columns]="resultColumns"
			[rows]="resultRows"
			[hidePaging]="true"
			[rowClass]="setRowClass"
			[sorts]="tableSorts"
			[sortType]="'single'"
			[selectionType]="'single'"
			[selectedRows]="selectedResultRows"
			(scroll)="onScroll($event, sourceTableId)"
			(select)="onSelectRow($event, 'result')"
			(activate)="onActivate($event)"
			(sort)="onSort($event, resultTableId)"
			(tableContextmenu)="onContextmenu($event)"
		></app-common-datagrid>
	</div>

	<ng-template #headerTempl let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
		<div class="datatable-header-cell-wrapper">
			<span class="column-header" (click)="sort()" appHtmlTooltip [tooltip]="column.info.tooltip">
				{{column.name}}
			</span>
		</div>
	</ng-template>
	<ng-template #checkboxHeaderTempl ngx-datatable-header-template>
		<div class="datatable-header-cell-wrapper">
			<input name="checkAll" type="checkbox" style="margin-left:0;" [(ngModel)]="isCheckAll" (ngModelChange)="onToggleCheckAll()">
		</div>
	</ng-template>
	<ng-template #parseCodeCellTempl let-row="row" let-column="column" let-value="value">
		<div class="parse-code-cell" [ngSwitch]="value" title="{{row[resultCol] ? row[resultCol][commentCol] : ''}}">
			<div *ngSwitchCase="'s'">
				<i class="glyphicons glyphicons-ok"></i>
			</div>
			<div *ngSwitchCase="'e'">
				<i class="glyphicons glyphicons-remove"></i>
			</div>
			<div *ngSwitchDefault>{{value}}</div> 
		</div>
	</ng-template>
	<ng-template #checkCellTempl let-row="row" let-rowIndex="rowIndex">
		<div class="check-cell">
			<input type="checkbox" [(ngModel)]="row[checkCol]" (ngModelChange)="onToggleCheck(rowIndex, row)">
		</div>
	</ng-template>

	<!-- Context menu -->
	<context-menu #tableContextmenu>
		<ng-template contextMenuItem let-item (execute)="copyNguid($event.item.row)">Copy Nguid</ng-template>
	</context-menu>

<!-- <as-split disabled direction="vertical" [gutterSize]="1">
	<as-split-area style="position:relative;" size="50">
		<div class="source-table">
			<app-common-datagrid
				[columns]="sourceColumns"
				[rows]="sourceRows"
			></app-common-datagrid>
		</div>
		<div class="middle-tab-section">
			<app-feat-layer-tabs></app-feat-layer-tabs>
		</div>
	</as-split-area>
	<as-split-area size="50">
		<div class="result-table">
			<app-common-datagrid
				[columns]="resultColumns"
				[rows]="resultRows"
			></app-common-datagrid>
		</div>
	</as-split-area>
</as-split> -->